<template>
  <c-dialog
    v-bind="$attrs"
    :persistent="persistent"
    width="684"
    :value="dialog"
    :actions="false"
    :closable="!persistent"
    @input="hideDialog">
    <template slot="title">
      <span class="title-text-2 semibold">{{ $t(`blocked_countries.title`)}}</span>
    </template>

    <CountryProfile :dark="dark" @close="hideDialog" />
  </c-dialog>
</template>
<script>
import CountryProfile from '@/components/countries/CountryProfile'

export default {
  name: 'CountryProfileDialog',
  components: { CountryProfile },
  props: {
    dark: { type: Boolean, default: null },
    dialog: { type: Boolean, default: true },
    persistent: Boolean
  },
  methods: {
    hideDialog () {
      this.$emit('update:dialog', false)
    }
  }
}
</script>
